import * as types from './types'

export default {
  [types.RESET_PAYMENTMETHOD](state, mode) {
    state.onboard.purchase.paymentMethod = null
  },
  [types.SET_TESTMODE](state, mode) {
    state.testMode = mode
  },
  [types.SET_DISABLE](state, value) {
    state.disable = value
  },
  [types.SET_FIRM_ONBOARD](state, data) {
    state.onboard = {
      basic: null,
      additional: null,
      shipping: null,
      purchase: null
    }
    if (data !== null) {
      state.onboard = data
    }
  },
  [types.PREP_ONBOARD](state, data) {
    state.onboard = {
      basic: null,
      additional: null,
      shipping: null,
      purchase: null
    }
  },
  [types.SET_ONBOARD](state, data) {
    if (state.onboard === undefined || state.onboard === null) {
      state.onboard = {
        basic: null,
        additional: null,
        shipping: null,
        purchase: null
      }
    }
    if (data !== null) {
      switch (data.type) {
        case 'basic':
          state.onboard.basic = JSON.parse(JSON.stringify(data))
          break
        case 'additional':
          state.onboard.additional = JSON.parse(JSON.stringify(data))
          break
        case 'shipping':
          state.onboard.shipping = JSON.parse(JSON.stringify(data))
          state.onboard.shipping.firm = state.onboard.additional.firm
          break
        case 'purchase':
          state.onboard.purchase = JSON.parse(JSON.stringify(data))
          state.onboard.purchase.firm = state.onboard.additional.firm
          break
        case 'product':
          state.onboard.purchase.product = data.product
          break
      }
    }
  },
  [types.SET_BASICID](state, id) {
    state.onboard.basic.marketing = id
  },
  [types.SET_FIRMID](state, firm) {
    if (firm === '') {
      firm = null
    }
    state.onboard.additional.firm = firm
  },
  [types.SET_SHIPID](state, id) {
    state.onboard.shipping.id = id
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/onboard/mutations.js